import { render, staticRenderFns } from "./BannerGaleriaTemplate.vue?vue&type=template&id=ad550c18&scoped=true&lang=pug"
import script from "./BannerGaleriaTemplate.vue?vue&type=script&lang=js"
export * from "./BannerGaleriaTemplate.vue?vue&type=script&lang=js"
import style0 from "./BannerGaleriaTemplate.styl?vue&type=style&index=0&id=ad550c18&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad550c18",
  null
  
)

export default component.exports